<template>
    <div>
        <!-- 退件 Modal -->
        <div class="modal fade" id="rejectModal" tabindex="-1" role="dialog" >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{$t('Request_Vue.Reject')}}
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="field">
                                    <div class="field-name">{{$t('Request_Vue.RejectReason')}}</div>
                                    <textarea v-model="rejectContent" maxlength="400"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-gray" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                        <button type="button" class="btn btn-danger" data-dismiss="modal" @click="confirmData">{{$t('Buttons.Ok')}}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {   
            rejectContent: ''        
        }
    },
    props : {                
    },
    methods: {
        confirmData (){
            if(!this.rejectContent){
                this.$alert('需填寫退件原因!','警告',{type: 'warning'});
                return;
            }
            this.$emit('finishReject' , this.rejectContent);
            this.rejectContent = ''; //清空
        }
    },
}
</script>

<style lang="scss" scoped>
.btn-blue {
    color: #fff !important;
    font-size: .85em;
    background: #343b55;
}

.btn-gray {
    background-color: gray;
    color: white;
}

.modal-body .alert-box .alert-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
}

.modal-body {
    background-color: #ECEEF6;
}

.field-name {
    font-weight: bolder;
    color: #000;
}

</style>